/* UI-DESIGN: shared gold lotus illustration (mystery cards, lobby header, invitation).
   Inherits its color from CSS `color`, so themes/tints stay in the stylesheets. */

const PETALS: { angle: number; length: number; width: number }[] = [
  { angle: -72, length: 42, width: 12 },
  { angle: 72, length: 42, width: 12 },
  { angle: -54, length: 58, width: 13 },
  { angle: 54, length: 58, width: 13 },
  { angle: -36, length: 74, width: 14 },
  { angle: 36, length: 74, width: 14 },
  { angle: -18, length: 88, width: 15 },
  { angle: 18, length: 88, width: 15 },
  { angle: 0, length: 100, width: 16 },
];

const petalPath = (l: number, w: number) =>
  `M0 0 C ${-w} ${-l * 0.45}, ${-w * 0.6} ${-l * 0.85}, 0 ${-l} C ${w * 0.6} ${-l * 0.85}, ${w} ${-l * 0.45}, 0 0 Z`;

const Lotus = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 220 130"
    fill="currentColor"
    aria-hidden
    focusable="false"
  >
    <g transform="translate(110 124)">
      {PETALS.map(({ angle, length, width }) => (
        <path
          key={angle}
          d={petalPath(length, width)}
          transform={`rotate(${angle})`}
          fillOpacity={1 - Math.abs(angle) / 220}
          stroke="#000"
          strokeOpacity={0.22}
          strokeWidth={1.5}
        />
      ))}
    </g>
  </svg>
);

export default Lotus;
